export default __webpack_public_path__ + "static/media/shoes16.c22333e2.jpeg";